import { Routes, Route } from "react-router-dom";
import NavMenu from "./components/NavMenu/NavMenu";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Settings from "./pages/settings/Settings";
import ColorCustomizer from "./pages/color-customizer/ColorCustomizer";
import Permission from "./pages/permission/Permission";
import Reset from "./pages/reset/Reset";
import OtherPlugins from "./pages/other-plugins";
import UserRoleEditor from "./pages/user-role-editor";
import Extra from "./pages/extra";
import RoleManager from "./pages/role-manager";
import BackupRestoreRole from "./pages/backup-restore-role"

import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.scss";
import Breadcrumb from "./components/NavMenu/Breadcrumb";

export default function App() {
	return (
		<>
			<Header />
			<NavMenu />
			<Breadcrumb />

			<div className="content-area">
				<Routes>
					<Route path="/" element={<Settings />} />
					<Route path="/settings" element={<Settings />} />
					<Route path="/color-customizer" element={<ColorCustomizer />} />
					<Route path="/permission" element={<Permission />} />
					<Route path="/reset" element={<Reset />} />
					<Route path="/other-plugins" element={<OtherPlugins />} />
					<Route path="/edit-role" element={<UserRoleEditor />} />
					<Route path="/extra" element={<Extra />} />
					<Route path="/role-manager" element={<RoleManager />} />
					<Route path="/backup-and-restore-role" element={<BackupRestoreRole />} />

				</Routes>
			</div>

			<Footer />
		</>
	);
}
